import styled from 'styled-components';
// import Img from 'gatsby-image';

import FormattedHtml from '../formattedHtml/formattedHtml';
import { mobileFirstMedia as media } from '../../config/theme';

export const Grid = styled.article`
  display: grid;
  grid-gap: 40px;

  @media (${media.l}) {
    grid-template-columns: 350px 1fr;
    grid-row-gap: 0;
  }
`;

export const Subgrid = styled.div`
  display: grid;
  grid-gap: 30px;
  align-items: start;
`;

export const ImageArea = styled.div`
  /* filter: drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 20px); */

  @media (${media.m}) {
    grid-row-start: 1;
    grid-row-end: 3;
    align-self: flex-start;
  }
`;

export const Image = styled.img`
  width: 100%;
  max-width: 350px;
  /* height: 100%; */
  clip-path: polygon(
    calc(var(--cropSize) * 0.7) 0,
    100% 0,
    100% 100%,
    0 100%,
    0 calc(var(--cropSize) * 0.7)
  );
`;

export const NameArea = styled.div``;

export const DescriptionArea = styled(FormattedHtml)`
  ul {
    margin: 0;
  }
`;
